//
// TransportWarning.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "@sas-dvr/ltjs-commons/models/warnings/Warning";

var TransportWarning = createModule("transport::TransportWarning", ["commons::Warning"], ClosetObject, [
    {
        INVALID_MEDIA: 60021,
        LOCAL_RESOURCE_EXPIRED: 60022,
        DUPLICATE_SUBSCRIBED_FOLDER: 60027,
        SERVICE_FAILURE: 60031,
        COMPLETE_WITH_WARNINGS: 60040,
        NOT_IN_ALLOWLIST: 60018,
        RESOURCE_NOT_ACCESSIBLE: 60020,
        UNAUTHORIZED: 60016,
        DUPLICATE_INSIGHT: 60028,
        PASSWORD_LOOKUP_FAILED: 60034,
        REQUEST_CANCELLED: 60035,
        CONFIGURATION_ERROR: 60038,
        DUPLICATE_REPORT: 60025,
        RESOURCE_NOT_FOUND: 60019,
        SAVE_REPORT_FAILED: 60044,
        DUPLICATE_CONNECTION_DESCRIPTION: 60024,
        SYSTEM_QUIESCED: 60037,
        STATUS_UNAVAILABLE: 60041,
        DUPLICATE_CONNECTION: 60023,
        CONNECTION_USER_MISMATCH: 60045,
        REPORT_ALREADY_UPDATING: 60043,
        SERVER_VERSION_NOT_SUPPORTED: 60012,
        PASSWORD_STORAGE_FAILED: 60033,
        SERVER_UNAVAILABLE: 60011,
        UNSUPPORTED_REQUEST: 60014,
        DUPLICATE_FILE: 60030,
        CERTIFICATE_ERROR: 60013,
        INVALID_ARGUMENTS: 60015,
        DUPLICATE_COLLECTION: 60026,
        LOCAL_OPERATION_FAILED: 60032,
        CANNOT_DOWNGRADE_REPORT: 60042,
        NETWORK_UNAVAILABLE: 60010,
        TIMEOUT: 60039,
        CAS_UPLOAD_FAILED: 60046,
        DUPLICATE_FOLDER: 60029,
        UNABLE_TO_CANCEL_REQUEST_COMPLETE: 60036,
        DENYLISTED: 60017,
    },
    ,
    ,
    ,
    ,
    ,
    ,
]);
export default TransportWarning;
